import { useAuth } from "react-oidc-context";
import { Link } from "react-router-dom";
import { FullPageMessage } from "../components/FullPageMessage";

export function AuthCallbackPage() {
  const auth = useAuth();
  if (auth.error) {
    return (
      <FullPageMessage title="Sign-in didn't complete">
        <p className="muted">{auth.error.message}</p>
        <Link to="/app" className="btn btn-primary">
          Try again
        </Link>
      </FullPageMessage>
    );
  }
  return <FullPageMessage title="Signing you in…" busy />;
}
